import { resetProductFilters } from '@/redux/reducers/products-reducer';
import { getProductBrandUrl } from '@/url/product';
import Link from 'next/link';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getImageUrl } from '@/utils/string';
import useWindowDimensions from '@/app/hooks/useWindowSize';
import { brandCardTypes, imageTypes, screenTypes } from '@/constants/types';
import ImageComponentV2 from '../Image/ImageComponentV2';

function BrandCardDesktop({ brand, type = brandCardTypes.top }) {
  const dispatch = useDispatch();
  const windowDimensions = useWindowDimensions();

  const getImageDimensionUrl = (url) => {
    if (!url) return null;

    const imageSize =
      windowDimensions.width > screenTypes.large
        ? url?.icon?.large
        : url?.icon?.small;

    return imageSize;
  };

  if (type === brandCardTypes.other) {
    return (
      <Link
        prefetch={false}
        href={`${getProductBrandUrl({ slug: brand?.slug })}`}
        aria-label="Go to brand page"
      >
        <div
          role="presentation"
          className="other-brand-card  bg-pale-grey w-[115px] lg:w-[300px] h-[54px] lg:h-[113px] flex justify-center brands-center p-2 lg:p-30 rounded-xl shadow-what-are-you-looking-for-box-shadow cursor-pointer hover:shadow-card-hover transition-colors duration-100"
          onClick={() => {
            dispatch(resetProductFilters());
          }}
        >
          <ImageComponentV2
            src={brand ? getImageUrl(getImageDimensionUrl(brand)) : null}
            alt={brand?.name?.en}
            className="w-full h-full object-contain object-center"
            type={imageTypes.wide}
            width={300}
            height={113}
            loading="lazy"
          />
        </div>
      </Link>
    );
  }

  return (
    <Link
      prefetch={false}
      aria-label="Go to brand page"
      href={`${getProductBrandUrl({ slug: brand?.slug })}`}
      passHref
      className="w-full max-w-max h-full flex flex-col items-center gap-2"
    >
      <div
        role="presentation"
        className="top-brand-card max-h-[53px] lg:max-h-[150px] flex justify-center cursor-pointer rounded-xl hover:shadow-card-hover transition-colors duration-100"
        onClick={() => {
          dispatch(resetProductFilters());
        }}
      >
        <ImageComponentV2
          src={brand ? getImageUrl(getImageDimensionUrl(brand)) : null}
          alt={brand?.name?.en}
          className="w-full max-w-[104px] lg:max-w-[400px] h-full max-h-[53px] lg:max-h-[150px] object-contain object-center rounded-xl"
          type={imageTypes.wide}
          width={400}
          height={150}
          loading="lazy"
        />
      </div>
    </Link>
  );
}

export default BrandCardDesktop;
